import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled, useTheme } from "@mui/material/styles";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const ChartFilter = (props) => {
  const { onFilterTextBoxChanged, searchValue, rowData, btnExpand, expand, handleAddHeadDialogOpen } = props;
  const [accountCode, setAccountCode] = useState("");
  const [accountName, setAccountName] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box className="p-24" sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className="flex justify-end">
              {/*<FormControl className="flex flex-row">*/}
              {/*  <div className="mr-16">*/}
              {/*    <label>Search</label>*/}
              {/*    <Autocomplete*/}
              {/*      open={open}*/}
              {/*      onOpen={() => {*/}
              {/*        if (inputValue) {*/}
              {/*          setOpen(true);*/}
              {/*        }*/}
              {/*      }}*/}
              {/*      onClose={() => setOpen(false)}*/}
              {/*      freeSolo*/}
              {/*      sx={{ width: 300 }}*/}
              {/*      // options={rowData.map((option) => option.name)}*/}
              {/*      options={rowData}*/}
              {/*      getOptionLabel={(option) =>*/}
              {/*        typeof option === "string" ? option : option.name*/}
              {/*      }*/}
              {/*      value={accountName}*/}
              {/*      inputValue={inputValue}*/}
              {/*      onChange={(event, newValue) => {*/}
              {/*        setAccountName(newValue);*/}
              {/*        searchValue(newValue.name);*/}
              {/*        if(event.keyCode === 13) {*/}
              {/*          searchValue(newValue);*/}
              {/*        }*/}
              {/*      }}*/}
              {/*      onInputChange={(event, newInputValue) => {*/}
              {/*        setInputValue(newInputValue.toUpperCase());*/}
              {/*        searchValue(newInputValue.toUpperCase());*/}
              {/*      }}*/}
              {/*      renderOption={(props, option) => (*/}
              {/*        <Box component="li" {...props}>*/}
              {/*          {option.name} ({option.shortForm})*/}
              {/*        </Box>*/}
              {/*      )}*/}
              {/*      renderInput={(params) => (*/}
              {/*        <StyledTextField*/}
              {/*          {...params}*/}
              {/*          sx={{ input: { textTransform: "uppercase" } }}*/}
              {/*        />*/}
              {/*      )}*/}
              {/*    />*/}
              {/*  </div>*/}
              {/*</FormControl>*/}
              <div className="mt-24">
              <Button
                variant="contained"
                color="primary"
                type="button"
                onClick={btnExpand}
                className="mr-8"
              >
                {expand ? 'Expand All' : 'Collapse All'}
              </Button>
              <Button
                color="warning"
                variant="contained"
                startIcon={
                  <FuseSvgIcon size={18}>
                    heroicons-outline:plus
                  </FuseSvgIcon>
                }
                onClick={handleAddHeadDialogOpen}
              >
                Add Head
              </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ChartFilter;
